import { useState } from 'react'
import { supabase } from '../lib/supabase.js'
import { T, C } from '../lib/theme.js'

const FILIERES = [
  "Médecine (PASS)","Médecine (L.AS)","Pharmacie","Odontologie","Maïeutique (Sage-femme)",
  "Kinésithérapie","Infirmier(e)","Orthophoniste","Orthoptiste","Ergothérapeute",
  "Psychomotricien(ne)","Manipulateur radio","Médecine vétérinaire",
  "Mathématiques","Informatique","Physique","Chimie","Sciences de la Terre",
  "Astronomie","Statistiques","Data Science","Biologie","Biochimie","SVT",
  "Génie Civil","Génie Mécanique","Génie Électrique","Génie Industriel",
  "Génie Chimique","Robotique","Électronique","Automatique",
  "Intelligence Artificielle","Cybersécurité","Réseaux et Télécommunications",
  "Développement Logiciel","Métiers du Multimédia et Internet",
  "Droit Public","Droit Privé","Droit International","Droit Pénal","Droit des Affaires","Droit Fiscal",
  "Économie","Gestion","Finance","Comptabilité","Marketing","Management","AES",
  "Psychologie Clinique","Psychologie Cognitive","Neuropsychologie","Psychologie Sociale",
  "Histoire","Géographie","Philosophie","Sociologie","Anthropologie","Archéologie",
  "Science Politique","Relations Internationales","Administration Publique",
  "Lettres Modernes","Lettres Classiques","Littérature Comparée","LLCER","LEA","Traduction",
  "Arts Plastiques","Cinéma","Théâtre","Design","Architecture","DN MADE",
  "STAPS - Entraînement Sportif","STAPS - Management du Sport","STAPS - Éducation et Motricité",
  "Prépa MPSI","Prépa MP2I","Prépa PCSI","Prépa PTSI","Prépa BCPST","Prépa TSI","Prépa TB",
  "Prépa MP","Prépa MPI","Prépa PC","Prépa PSI","Prépa PT",
  "Prépa ECG","Prépa ECT","Hypokhâgne","Khâgne","Prépa ATS","CUPGE",
  "BTS MCO","BTS NDRC","BTS Gestion PME","BTS Comptabilité Gestion","BTS SIO",
  "BTS Électrotechnique","BTS Maintenance Industrielle","BTS Bâtiment","BTS Travaux Publics",
  "BTS Audiovisuel","BTS Communication","BTS Tourisme","BTS Hôtellerie-Restauration","BTSA","BTSM",
  "BUT Informatique","BUT Réseaux et Télécommunications","BUT Génie Mécanique",
  "BUT Génie Électrique","BUT Génie Civil","BUT Génie Chimique","BUT Mesures Physiques",
  "BUT Chimie","BUT Biologie","BUT GEA","BUT Techniques de Commercialisation",
  "BUT Information-Communication","BUT Carrières Sociales","BUT MMI",
  "DCG","DSCG","DEUST","Licence Pro","Diplôme d'ingénieur","Diplôme d'école de commerce",
  "Diplôme d'architecte","Doctorat","Autre"
]
const ANNEES = [
  "L1 (Bac+1)","L2 (Bac+2)","L3 (Bac+3)",
  "M1 (Bac+4)","M2 (Bac+5)",
  "Doctorat 1ère année","Doctorat 2ème année","Doctorat 3ème année","Post-doc",
  "PASS","LAS 1","LAS 2","LAS 3",
  "DFGSM2 (D1)","DFGSM3 (D2)","DFASM1 (D3)","DFASM2 (D4)","DFASM3 (D5)",
  "Externat D6","Internat D7","Internat D8","Internat D9",
  "Pharmacie P1","Pharmacie P2","Pharmacie P3","Pharmacie P4","Pharmacie P5","Pharmacie P6",
  "Prépa 1ère année","Prépa 2ème année",
  "BTS 1ère année","BTS 2ème année",
  "BUT 1ère année","BUT 2ème année","BUT 3ème année",
  "Licence Pro","Diplôme ingénieur 1A","Diplôme ingénieur 2A","Diplôme ingénieur 3A",
  "École de commerce 1A","École de commerce 2A","École de commerce 3A",
  "DEUST 1ère année","DEUST 2ème année","Autre"
]

// SVG eye icons — remplacent les emojis 👁️ / 🙈
function EyeIcon({ open }) {
  return open ? (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  ) : (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  )
}

function OnboardingStep({ onSave, onSkip }) {
  const [universite, setUniversite] = useState('')
  const [filiere, setFiliere] = useState('')
  const [annee, setAnnee] = useState('')
  const [loading, setLoading] = useState(false)

  const inp = { width:'100%', padding:'12px 16px', background:'#ffffff08', border:'1px solid var(--bd)', borderRadius:10, color:'var(--t1)', fontFamily:'var(--font-body)', fontSize:'0.95rem', outline:'none' }
  const lbl = { display:'block', fontSize:'0.8rem', color:'var(--t3)', marginBottom:6, fontWeight:500, textTransform:'uppercase', letterSpacing:'0.06em' }
  const sel = { ...inp, cursor:'pointer' }

  async function handleSave() {
    setLoading(true)
    await onSave({ universite, filiere, annee })
    setLoading(false)
  }

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)', backgroundImage:'radial-gradient(ellipse 60% 50% at 50% 0%, #c9a96e10 0%, transparent 70%)', padding:24 }}>
      <div style={{ width:'100%', maxWidth:420 }}>
        <div style={{ background:'var(--bg2)', border:'1px solid var(--bd)', borderRadius:20, padding:36 }} className="fade-up">
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:'1.6rem', fontWeight:700, marginBottom:6 }}>Ton profil étudiant</h1>
          <p style={{ color:'var(--t3)', fontSize:'0.88rem', marginBottom:28 }}>Ces infos nous aident à te suggérer du contenu. Tu peux les modifier à tout moment.</p>

          <div style={{ marginBottom:18 }}>
            <label style={lbl}>Université / Faculté</label>
            <input style={inp} type="text" value={universite} onChange={e => setUniversite(e.target.value)} placeholder="Ex: Université Paris-Saclay"
              onFocus={e => e.target.style.borderColor='var(--gold)60'} onBlur={e => e.target.style.borderColor='var(--bd)'} />
          </div>

          <div style={{ marginBottom:18 }}>
            <label style={lbl}>Filière</label>
            <select style={sel} value={filiere} onChange={e => setFiliere(e.target.value)}>
              <option value="">Sélectionner...</option>
              {FILIERES.map(function(f) { return <option key={f} value={f}>{f}</option> })}
            </select>
          </div>

          <div style={{ marginBottom:28 }}>
            <label style={lbl}>Année d'étude</label>
            <select style={sel} value={annee} onChange={e => setAnnee(e.target.value)}>
              <option value="">Sélectionner...</option>
              {ANNEES.map(function(a) { return <option key={a} value={a}>{a}</option> })}
            </select>
          </div>

          <button onClick={handleSave} disabled={loading} style={{ width:'100%', padding:'13px', background:loading?'#5C1A2490':'#5C1A24', color:'#D4A860', border:'none', borderRadius:10, fontFamily:'var(--font-body)', fontWeight:700, fontSize:'0.95rem', cursor:loading?'not-allowed':'pointer', marginBottom:12, transition:'all .2s' }}>
            {loading ? 'Enregistrement...' : 'Enregistrer mon profil'}
          </button>
          <button onClick={onSkip} style={{ width:'100%', padding:'10px', background:'transparent', color:'var(--t3)', border:'none', cursor:'pointer', fontSize:'0.88rem', fontFamily:'var(--font-body)' }}>
            Passer cette étape →
          </button>
        </div>
      </div>
    </div>
  )
}

export default function AuthPage({ onBack, showResetForm }) {
  const [mode, setMode]       = useState(() => (window._isRecovery || showResetForm) ? 'newpassword' : 'login')
  const [email, setEmail]     = useState('')
  const [password, setPassword] = useState('')
  const [name, setName]       = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError]     = useState('')
  const [success, setSuccess] = useState('')
  const [showPwd, setShowPwd] = useState(false)
  const [showOnboarding, setShowOnboarding] = useState(false)
  const [newPassword, setNewPassword] = useState('')
  const [newUserId, setNewUserId] = useState(null)
  const [confirmPassword, setConfirmPassword] = useState('')
  const [emailError, setEmailError] = useState('')
  const [rememberMe, setRememberMe] = useState(true)

  const validateEmail = (v) => {
    if (!v) { setEmailError(''); return }
    const ok = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)
    setEmailError(ok ? '' : 'Email invalide')
  }

  const handle = async (e) => {
    e.preventDefault()
    setLoading(true); setError(''); setSuccess('')
    try {
      if (mode === 'login') {
        localStorage.setItem('sf-remember-me', rememberMe ? 'true' : 'false')
        const { error } = await supabase.auth.signInWithPassword({ email, password })
        if (error) throw error
      } else if (mode === 'signup') {
        if (password.length < 8) { setError('Le mot de passe doit faire au moins 8 caractères'); setLoading(false); return }
        if (!/\d/.test(password)) { setError('Le mot de passe doit contenir au moins un chiffre'); setLoading(false); return }
        if (password !== confirmPassword) { setError('Les mots de passe ne correspondent pas'); setLoading(false); return }
        const { data, error } = await supabase.auth.signUp({ email, password, options: { data: { full_name: name.trim().split(' ').map(w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase()).join(' ') } } })
        if (error) throw error
        if (data?.user) {
          setNewUserId(data.user.id)
          if (data.user.email_confirmed_at) { setShowOnboarding(true) }
          else { setShowOnboarding(true) } // onboarding d'abord, email confirm après
        } else {
          setSuccess('Compte créé ! Vérifie ton email pour activer ton compte.')
        }
      } else if (mode === 'newpassword') {
        if (!newPassword || newPassword.length < 6) { setError('Le mot de passe doit faire au moins 6 caractères'); setLoading(false); return }
        const { error } = await supabase.auth.updateUser({ password: newPassword })
        if (error) setError(error.message)
        else { setSuccess('Mot de passe mis à jour ! Tu peux te connecter.'); setMode('login'); window.history.replaceState({}, '', '/') }
      } else if (mode === 'reset') {
        const { error } = await supabase.auth.resetPasswordForEmail(email, { redirectTo: window.location.origin })
        if (error) throw error
        setSuccess('Email de réinitialisation envoyé !')
      }
    } catch(e) {
      const msg = e.message || 'Une erreur est survenue'
      if (msg.includes('Invalid login') || msg.includes('invalid_credentials')) setError('Email ou mot de passe incorrect')
      else if (msg.includes('already registered') || msg.includes('already been registered')) setError('Cet email est déjà utilisé')
      else if (msg.includes('Password should') || msg.includes('password')) setError('Le mot de passe doit faire au moins 6 caractères')
      else if (msg.includes('Email not confirmed')) setError('Confirme ton email avant de te connecter')
      else if (msg.includes('User not found')) setError('Aucun compte avec cet email')
      else if (msg.includes('rate limit')) setError('Trop de tentatives, réessaie dans quelques minutes')
      else if (msg.includes('network')) setError('Problème de connexion, réessaie')
      else setError(msg)
    }
    setLoading(false)
  }

  async function handleOnboardingSave({ universite, filiere, annee }) {
    if (newUserId) {
      await supabase.from('profiles').upsert({ id: newUserId, universite, filiere, annee, cours_credits: 2, plan: 'free' }, { onConflict: 'id' })
    }
    setShowOnboarding(false)
    setSuccess('Compte créé ! Vérifie ton email pour confirmer.')
  }

  if (showOnboarding) return <OnboardingStep onSave={handleOnboardingSave} onSkip={function() { setShowOnboarding(false); setSuccess('Compte créé ! Vérifie ton email pour confirmer.') }} />

  const inp = { width:'100%', padding:'12px 16px', background:'#ffffff08', border:'1px solid var(--bd)', borderRadius:10, color:'var(--t1)', fontFamily:'var(--font-body)', fontSize:'0.95rem', outline:'none', transition:'border-color .15s' }
  const lbl = { display:'block', fontSize:'0.8rem', color:'var(--t3)', marginBottom:6, fontWeight:500, textTransform:'uppercase', letterSpacing:'0.06em' }

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg)', backgroundImage:'radial-gradient(ellipse 60% 50% at 50% 0%, #c9a96e10 0%, transparent 70%)', padding:24 }}>
      <div style={{ width:'100%', maxWidth:420 }}>
        <button onClick={onBack} style={{ background:'none', border:'none', color:'var(--t3)', cursor:'pointer', fontSize:'0.85rem', marginBottom:32, display:'flex', alignItems:'center', gap:6, fontFamily:'var(--font-body)' }}>← Retour à l'accueil</button>
        <div style={{ background:'var(--bg2)', border:'1px solid var(--bd)', borderRadius:20, padding:36 }} className="fade-up">
          <h1 style={{ fontFamily:'var(--font-display)', fontSize:'1.8rem', fontWeight:700, marginBottom:6, letterSpacing:'-0.02em' }}>
            {mode === 'login' ? 'Bon retour' : mode === 'signup' ? 'Rejoins Flashia' : mode === 'newpassword' ? 'Nouveau mot de passe' : 'Mot de passe oublié'}
          </h1>
          <p style={{ color:'var(--t3)', fontSize:'0.88rem', marginBottom:28 }}>
            {mode === 'login' ? 'Connecte-toi pour accéder à ton espace' : mode === 'signup' ? 'Crée ton compte — 2 cours offerts' : mode === 'newpassword' ? 'Choisis ton nouveau mot de passe' : 'Entre ton email pour recevoir un lien'}
          </p>
          <form onSubmit={handle}>
            {mode === 'signup' && (
              <div style={{ marginBottom:18 }}>
                <label style={lbl}>Prénom & Nom</label>
                <input style={inp} type="text" value={name} onChange={e => setName(e.target.value)} placeholder="Marie Dupont" required onFocus={e => e.target.style.borderColor='var(--gold)60'} onBlur={e => e.target.style.borderColor='var(--bd)'} />
              </div>
            )}
            {mode !== 'newpassword' && <div style={{ marginBottom:18 }}>
              <label style={lbl}>Email</label>
              <input style={{...inp, borderColor: emailError ? '#f87171' : undefined}} type="email" value={email}
                onChange={e => { setEmail(e.target.value); validateEmail(e.target.value) }}
                placeholder="marie@email.com" required
                onFocus={e => e.target.style.borderColor='var(--gold)60'}
                onBlur={e => e.target.style.borderColor= emailError ? '#f87171' : 'var(--bd)'} />
              {emailError && <div style={{ color:'#f87171', fontSize:'0.75rem', marginTop:4 }}>{emailError}</div>}
            </div>}
            {mode === 'signup' && (
              <div style={{ marginBottom:18 }}>
                <label style={lbl}>MOT DE PASSE</label>
                <div style={{ position:'relative' }}>
                  <input style={{...inp, paddingRight:44, borderColor: confirmPassword && confirmPassword !== password ? '#f87171' : confirmPassword && confirmPassword === password ? '#34d399' : undefined}}
                    type={showPwd ? 'text' : 'password'} value={confirmPassword}
                    onChange={e => setConfirmPassword(e.target.value)}
                    placeholder="••••••••" required
                    onFocus={e => e.target.style.borderColor='var(--gold)60'}
                    onBlur={e => e.target.style.borderColor= confirmPassword !== password ? '#f87171' : 'var(--bd)'} />
                </div>
              </div>
            )}
            {mode === 'newpassword' && (
              <div style={{ marginBottom:24 }}>
                <label style={lbl}>Nouveau mot de passe</label>
                <div style={{ position:'relative' }}>
                  <input style={{...inp, paddingRight:44}} type={showPwd ? 'text' : 'password'} value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="Min. 8 caractères avec un chiffre" required minLength={8} onFocus={e => e.target.style.borderColor='var(--gold)60'} onBlur={e => e.target.style.borderColor='var(--bd)'} />
                  <button type="button" onClick={() => setShowPwd(p => !p)}
                    style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--t3)', padding:4, lineHeight:1, display:'flex', alignItems:'center' }}>
                    <EyeIcon open={showPwd} />
                  </button>
                </div>
              </div>
            )}
            {mode !== 'reset' && mode !== 'newpassword' && (
              <div style={{ marginBottom:24 }}>
                <label style={lbl}>{mode === 'signup' ? 'CONFIRMER LE MOT DE PASSE' : 'MOT DE PASSE'}</label>
                <div style={{ position:'relative' }}>
                  <input style={{...inp, paddingRight:44}} type={showPwd ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} placeholder={mode === 'signup' ? 'Répète ton mot de passe' : '••••••••'} required minLength={8} onFocus={e => e.target.style.borderColor='var(--gold)60'} onBlur={e => e.target.style.borderColor='var(--bd)'} />
                  <button type="button" onClick={() => setShowPwd(p => !p)}
                    style={{ position:'absolute', right:12, top:'50%', transform:'translateY(-50%)', background:'none', border:'none', cursor:'pointer', color:'var(--t3)', padding:4, lineHeight:1, display:'flex', alignItems:'center' }}>
                    <EyeIcon open={showPwd} />
                  </button>
                </div>
              </div>
            )}
            {error   && <div style={{ background:'#f8717115', border:'1px solid #f8717130', borderRadius:8, padding:'10px 14px', color:'#f87171', fontSize:'0.85rem', marginBottom:16 }}>{error}</div>}
            {success && <div style={{ background:'#7A9E7E15', border:'1px solid #7A9E7E40', borderRadius:8, padding:'10px 14px', color:'#7A9E7E', fontSize:'0.85rem', marginBottom:16 }}>{success}</div>}
            {mode === 'signup' && (
              <div style={{ fontSize:'0.78rem', color:'var(--t3)', marginBottom:12, lineHeight:1.5, textAlign:'center' }}>
                En créant un compte, tu acceptes nos{' '}
                <a href="/cgu" target="_blank" style={{ color:'var(--gold)', textDecoration:'underline' }}>CGU</a>
                {' '}et notre{' '}
                <a href="/confidentialite" target="_blank" style={{ color:'var(--gold)', textDecoration:'underline' }}>Politique de confidentialité</a>.
              </div>
            )}
            {mode === 'login' && (
              <div style={{ display:'flex', alignItems:'center', gap:10, marginBottom:16, cursor:'pointer' }} onClick={() => setRememberMe(r => !r)}>
                <div style={{ width:18, height:18, borderRadius:5, border:'2px solid', borderColor:rememberMe?'var(--gold)':'var(--bd)', background:rememberMe?'var(--gold)':'transparent', display:'flex', alignItems:'center', justifyContent:'center', transition:'all .2s', flexShrink:0 }}>
                  {rememberMe && <span style={{ color:'var(--bg)', fontSize:'0.7rem', fontWeight:900 }}>✓</span>}
                </div>
                <span style={{ fontSize:'0.83rem', color:'var(--t2)', userSelect:'none' }}>Rester connecté</span>
              </div>
            )}
            <button type="submit" disabled={loading} style={{ width:'100%', padding:'13px', background:loading?'#5C1A2490':'#5C1A24', color:'#D4A860', border:'none', borderRadius:10, fontFamily:'var(--font-body)', fontWeight:700, fontSize:'0.95rem', cursor:loading?'not-allowed':'pointer', transition:'all .2s', display:'flex', alignItems:'center', justifyContent:'center', gap:8 }}>
              {loading && <div style={{ width:16, height:16, border:'2px solid #D4A86040', borderTopColor:'#D4A860', borderRadius:'50%' }} className="spinner" />}
              {mode === 'login' ? 'Se connecter' : mode === 'signup' ? 'Créer mon compte' : mode === 'newpassword' ? 'Enregistrer le mot de passe' : 'Envoyer le lien'}
            </button>
          </form>
          <div style={{ marginTop:24, display:'flex', flexDirection:'column', gap:8, alignItems:'center' }}>
            {mode === 'login' && <>
              <button onClick={() => { setMode('signup'); setError('') }} style={{ background:'none', border:'none', color:'var(--t2)', cursor:'pointer', fontSize:'0.85rem', fontFamily:'var(--font-body)' }}>Pas encore de compte ? <span style={{ color:'var(--gold)' }}>S'inscrire</span></button>
              <button onClick={() => { setMode('reset'); setError('') }} style={{ background:'none', border:'none', color:'var(--t3)', cursor:'pointer', fontSize:'0.82rem', fontFamily:'var(--font-body)' }}>Mot de passe oublié ?</button>
            </>}
            {mode !== 'login' && (
              <button onClick={() => { setMode('login'); setError('') }} style={{ background:'none', border:'none', color:'var(--t2)', cursor:'pointer', fontSize:'0.85rem', fontFamily:'var(--font-body)' }}>Déjà un compte ? <span style={{ color:'var(--gold)' }}>Se connecter</span></button>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
